import React, { Component } from 'react';
import { Button, Table } from 'reactstrap';
import axiosInstance from '@src/axios-instance';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import SortableTh from '@components/SortableTh/SortableTh';
import RegionModal from './RegionModal/RegionModal';
import NameInput from './NameInput';

class SampleQuote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      regions: [],
      loaded: false,
      successSampleQuote: false,
      sampleQuote: '',
      confirmModalActive: false,
      sort: 'name',
      direction: 'ASC',
      limit: 1000,
      newRegionModal: false,
      loading: false,
      entityId: null
    };
  }

  openFilePicker = () => {
    this.fileUpload.click();
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  onFileSelect = e => {
    if (this.fileUpload.files.length > 0) {
      const formData = new FormData();
      formData.append('file_link', this.fileUpload.files[0]);

      axiosInstance()
        .post(
          `/sample-quote-regions/upload/${this.state.entityId}.json`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          this.getList({
            sort: this.state.sort,
            direction: this.state.direction
          });
        })
        .catch(err => {
          alert('Error');
        });
      this.fileUpload.value = '';
    }
  };

  getList = getData => {
    axiosInstance()
      .get('/sample-quote-regions.json', { params: getData })
      .then(response => {
        this.setState({
          loaded: true,
          loading: false,
          regions: response.data.list,
          sort: response.data.sort,
          direction: response.data.direction,
          newRegionModal: false,
          confirmModalActive: false,
          entityId: null
        });
      });
  };

  saveRegion = postData => {
    this.setState(
      {
        loading: true
      },
      () =>
        axiosInstance()
          .post('/sample-quote-regions.json', postData)
          .then(response => {
            this.getList({
              sort: this.state.sort,
              direction: this.state.direction
            });
          })
    );
  };

  onRegionRemove = () => {
    this.setState(
      {
        loading: true
      },
      () =>
        axiosInstance()
          .delete(`/sample-quote-regions/${this.state.entityId}.json`)
          .then(response => {
            this.getList({
              sort: this.state.sort,
              direction: this.state.direction
            });
          })
    );
  };

  componentDidMount = () => {
    this.getList({ sort: this.state.sort, direction: this.state.direction });
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  render = () => {
    return (
      <React.Fragment>
        <input
          ref={ref => (this.fileUpload = ref)}
          type={'file'}
          className={'d-none'}
          onChange={this.onFileSelect}
          accept={'.pdf'}
        />
        {this.state.loaded && (
          <div>
            <div className={'pb-2 text-right'}>
              <Button
                color={'secondary'}
                onClick={() => this.toggle('newRegionModal')}
              >
                Create New Region
              </Button>
            </div>
            <Table className={'mt-3'} hover={true}>
              <thead>
                <tr>
                  <SortableTh
                    {...this.state}
                    paginationFunc={this.getList}
                    label={'Region Name'}
                    field={'name'}
                  />
                  <SortableTh {...this.props} label={'File'} field={'name'} />
                  <th style={{ width: '250px' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.regions.map(item => {
                  return (
                    <tr key={`region-${item.id}`}>
                      <td>
                        <NameInput value={item.name} entityId={item.id} />
                      </td>
                      <td>
                        <a href={item.s3_link} target={'_blank'}>
                          {item.file_link !== null
                            ? item.file_link.replace(/^.*[/]/, '')
                            : ''}
                        </a>
                      </td>
                      <td>
                        <Button
                          size={'sm'}
                          color={'secondary'}
                          className={'mr-2'}
                          onClick={() => {
                            this.setState(
                              {
                                entityId: item.id
                              },
                              this.openFilePicker
                            );
                          }}
                        >
                          {item.file_link === null
                            ? 'Upload PDF'
                            : 'Update PDF'}
                        </Button>
                        <Button
                          size={'sm'}
                          color={'danger'}
                          onClick={() =>
                            this.setState({
                              confirmModalActive: true,
                              entityId: item.id
                            })
                          }
                        >
                          Delete Region
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {this.state.newRegionModal && (
              <RegionModal
                isActive={this.state.newRegionModal}
                toggle={() => this.toggle('newRegionModal')}
                onSubmit={this.saveRegion}
                loading={this.state.loading}
              />
            )}
            <ConfirmModal
              isActive={this.state.confirmModalActive}
              title={'Delete Region'}
              toggle={() => this.toggle('confirmModalActive')}
              body={
                'Please confirm before deleting this region. The sample quote file will also be deleted. This is not a reversible action.'
              }
              confirmLabel={'Yes, Delete Region and Sample Quote File'}
              confirmAction={this.onRegionRemove}
            />
          </div>
        )}
      </React.Fragment>
    );
  };
}
export default SampleQuote;
